var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2812 1.08398L13.6875 0.458984C13.5312 0.302734 13.2812 0.302734 13.1562 0.458984L7.5 6.11523L1.8125 0.458984C1.6875 0.302734 1.4375 0.302734 1.28125 0.458984L0.6875 1.08398C0.53125 1.20898 0.53125 1.45898 0.6875 1.61523L7.21875 8.14648C7.375 8.30273 7.59375 8.30273 7.75 8.14648L14.2812 1.61523C14.4375 1.45898 14.4375 1.20898 14.2812 1.08398Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIconBlack);
export default __webpack_public_path__ + "static/media/down-icon-black.6d3038ddd69f7f98ba8b7a69fcff411a.svg";
export { ForwardRef as ReactComponent };